<script>
    import { http } from '@/system/http.js';
    import hasSelectedProducts from '@/online_booking/new/mixins/hasSelectedProducts.js';
    import PaymentRateInterval from '@/core/PaymentRate/PaymentRateInterval';
    import ClientAddressInfo from '@/online_booking/new/components/common_booking/ClientAddressInfo.vue'
    import StepCounter from '@/online_booking/new/components/common/StepCounter';
    import Card from '@/online_booking/new/components/common/Card';
    import PreviousButton from '@/online_booking/new/components/common/PreviousButton';
    import EpButton from '@/system/components/global/button';
    import {mapActions, mapGetters, mapState} from 'vuex';

    export default {
        components: {
            ClientAddressInfo,
            StepCounter,
            PreviousButton,
            Card,
            EpButton,
        },
        data() {
            return {
                PaymentRateInterval,
                event: null,
                event_group: null,
                user: null,
                info: null,
                payment: null,
                dataFrm: null,
                slug: null,
                logged_in_client: null,
                loading: false,
                mailchimp_subscribe: false,
                is_consent_enabled: false,
                consent_settings: false,
                consent_accepted: false,
                payment_rate_request: 0,
                currency: Config.get('countries.' + locale + '.currency'),
            }

        },

        mixins: [hasSelectedProducts],

        mounted() {
            this.$event_bus.$on('confirmEvent', (data) => {
                this.setCurrentStep('confirmation');
                this.dataFrm = data.dataFrm;
                this.info = data.confirmInfo;

                this.$nextTick(function () {
                    $('#collapseEventConfirm').collapse('show');
                    $('#collapseFillEventInfo').collapse('hide');
                });
            });

            this.$event_bus.$on('LoadEventData', (data) => {
                this.event = data.event;
                this.event_group = data.event_group;
                this.slug = data.event.slug;
                this.user = data.user;
                this.logged_in_client = data.logged_in_client;
                this.is_consent_enabled = data.is_consent_enabled;
                this.consent_settings = data.consent_settings;
            });

            this.$event_bus.$on('FillEventInfoShowed', () => {
                this.payment_rate_request = 0;
            });

            $(document).on('show.bs.collapse', '#collapseEventConfirm', () => {
                this.$event_bus.$emit('ConfirmEventShowed');
            });
        },

        computed: {
            ...mapState('OnlineBooking', ['currentStep']),
            ...mapGetters('OnlineBooking', ['currentStepNumber', 'totalStepCount', 'getPreviousStepId']),

            firstPaymentRatePriceInCentsWithVat() {
                let price = this.event.first_payment_rate_price_in_cents_with_vat;

                if (this.event_group) {
                    price = this.event_group.first_payment_rate_price_in_cents_with_vat;
                }

                if (this.discountMoneyUsed) {
                    price = price - Math.round(this.discountMoneyUsed / this.event.payment_rates_number);
                }

                if (this.giftcardMoneyUsed) {
                    price = price - Math.round(this.giftcardMoneyUsed / this.event.payment_rates_number);
                }

                return Math.round(price);
            },

            firstPaymentRatePriceWithVatFormatted() {
                return `${this.event.currency} ${this.firstPaymentRatePriceInCentsWithVat / 100}`;
            },

            totalEventPriceToPayNow() {
                return this.event.price_in_cents_with_vat - this.discountMoneyUsed - this.giftcardMoneyUsed;
            },

            totalEventPriceToPayNowFormatted() {
                return this.event.currency + ' ' + (this.totalEventPriceToPayNow / 100);
            },

            showMailchimp() {
                return this.user.is_mailchimp_connected && this.user.event_setting.subscribe_mailchimp;
            },

            eventName() {
                return this.event_group ? this.event_group.name : this.event.name;
            },

            eventIntervalFormatted() {
                return this.event_group ? this.event_group.interval_formatted : this.event.interval_formatted;
            },

            should_show_payment_rates_option() {
                return this.user.is_payment_rates_active && !this.used_voucher && (this.event_group && this.event_group.payment_rates || this.event && this.event.payment_rates) && !this.show_waiting_list;
            },

            giftcardMoneyUsed() {
                if (!this.giftcard || this.giftcard.money_left <= 0) {
                    return 0;
                }

                let priceAfterDiscount = this.event.price_in_cents_with_vat - this.discountMoneyUsed;

                if (priceAfterDiscount - this.giftcard.money_left >= 0) {
                    return this.giftcard.money_left;
                } else {
                    return priceAfterDiscount;
                }
            },

            giftcardMoneyUsedFormatted() {
                return `${this.event.currency} ${(this.giftcardMoneyUsed / 100).toFixed(2)}`;
            },

            discountMoneyUsed() {
                if (!this.discount_code) {
                    return 0;
                }

                if (this.discount_code.type == 'percentage') {
                    return this.event.price_in_cents_with_vat * (this.discount_code.value / 100);
                } else {
                    return this.discount_code.value * 100;
                }
            },

            discountMoneyUsedFormatted() {
                return `${this.event.currency} ${(this.discountMoneyUsed / 100).toFixed(2)}`;
            },

            eventPriceWithDiscountFormatted() {
                const price = Math.max(0, this.event.price_in_cents_with_vat - this.discountMoneyUsed);

                return `${this.event.currency} ${(price / 100).toFixed(2)}`;
            },

            show_waiting_list() {
              return this.event.is_filled && this.event.can_clients_singnup_for_waiting_list;
            },

            isConfirmEventStepActive () {
                return this.currentStep === 'confirmation';
            }
        },

        methods: {
            ...mapActions('OnlineBooking', ['setCurrentStep']),

            approve(pay_now) {

                this.dataFrm.append('pay_now', pay_now);

                if(this.mailchimp_subscribe){
                    this.dataFrm.append('mailchimp_subscribe', this.mailchimp_subscribe);
                }

                if (this.consent_accepted) {
                    this.dataFrm.append('consent_accepted', this.consent_accepted);
                }

                this.dataFrm.append('payment_rate_request', this.payment_rate_request);

                if (this.giftcard) {
                    this.dataFrm.append('giftcard_id', this.giftcard.id);
                }

                if (this.discount_code) {
                    this.dataFrm.append('discount_code_id', this.discount_code.id);
                }

                this.loading = true;

                http.post('/event/' + this.slug + '/choose-client', this.dataFrm)
                    .then(({data}) => {
                        this.loading = false;

                        if (data.payment) {
                            this.$event_bus.$emit('eventPayment', {data: data.markup, dataFrm: this.dataFrm, payment_rate_request: this.payment_rate_request});
                        } else {
                            this.$event_bus.$emit('infoEventAdded', data.markup);
                        }
                    })
                    .catch(({error, errorBag}) => {
                        this.loading = false;
                        this.$setErrorBag(errorBag);
                    });
            },

            loaderOn() {
                this.loading = true;
            }
        },
    };
</script>

<template>
    <div v-if="isConfirmEventStepActive && user && event">
        <card class="p-0 rounded-lg" id="confirm-event-panel">
            <!-- Main Section Title -->
            <h4 class="section-title">
                <step-counter :current="currentStepNumber" :total="totalStepCount" />
                {{ trans('events.receipt') }}
            </h4>

            <!-- Main Content -->
            <form class="form-horizontal" role="form">
                <div
                    id="collapseEventConfirm"
                    role="tabpanel"
                    aria-labelledby="headingTwo"
                    data-parent="#event-accordion"
                >

                    <div class="panel-body pb-0" id="confirm-event-booking">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group m-b-10">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('online_booking.fill_name') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ eventName }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('online_booking.receipt_time') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            {{ eventIntervalFormatted }} <span>{{ $root.tzOffset }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="event.price_formatted_with_vat">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('global.price') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static" >
                                            {{ event.price_formatted_with_vat }}
                                            <span class="text-success" v-if="event.pay_before > 0 && !giftcardMoneyUsed && !used_voucher && !discountMoneyUsed && !show_waiting_list">({{ trans('online_booking.to_pay_now') }}: {{ totalEventPriceToPayNowFormatted }})</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="used_voucher">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('vouchers.title') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ used_voucher.name }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="discount_code && discountMoneyUsed">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('global.discount') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            - {{ discountMoneyUsedFormatted }}
                                            ({{ discount_code.code }}
                                            {{ discount_code.type == 'percentage' ? discount_code.value + '%' : currency + ' ' + discount_code.value }})
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="discount_code && discountMoneyUsed">
                                    <label class="col-sm-3 control-label mb-0" v-if="giftcardMoneyUsed">{{ trans('invoice.subtotal') }}</label>
                                    <label class="col-sm-3 control-label mb-0" v-else>{{ trans('invoice.total') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            {{ eventPriceWithDiscountFormatted }}
                                            <span class="text-success" v-if="event.pay_before > 0 && !giftcardMoneyUsed">
                                            ({{ trans('online_booking.to_pay_now') }}: {{ totalEventPriceToPayNowFormatted }})
                                        </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="giftcard && giftcardMoneyUsed">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('giftcards.title') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            - {{ giftcardMoneyUsedFormatted }} ({{ giftcard.name }})
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-10" v-if="giftcard && giftcardMoneyUsed">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('invoice.total') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">
                                            {{ totalEventPriceToPayNowFormatted }}
                                            <span class="text-success" v-if="event.pay_before > 0">({{ trans('online_booking.to_pay_now') }}: {{ totalEventPriceToPayNowFormatted }})</span>
                                        </div>
                                    </div>
                                </div>

                                <client-address-info
                                    v-if="info !== null"
                                    :info="info"
                                    :isClientLoggedIn="logged_in_client !== false"
                                ></client-address-info>

                                <div class="form-group m-b-10" v-if="info && info.notes">
                                    <label class="col-sm-3 control-label mb-0">{{ trans('online_booking.fill_notes') }}</label>
                                    <div class="col-sm-9">
                                        <div class="form-control-static">{{ info.notes }}</div>
                                    </div>
                                </div>

                                <div class="form-group m-b-15" v-if="showMailchimp">
                                    <div class="col-sm-12">
                                        <div class="checkbox">
                                            <input id="mailchimp_subscribe" type="checkbox" name="mailchimp_subscribe" v-model="mailchimp_subscribe">
                                            <label for="mailchimp_subscribe">
                                                {{ trans('online_booking.newsletter_receive') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group m-b-15" v-if="should_show_payment_rates_option">
                                    <div class="col-sm-12">
                                        <div class="checkbox">
                                            <input id="payment_rate_request" type="checkbox" v-bind:true-value="1" v-bind:false-value="0" name="payment_rate_request" v-model="payment_rate_request">
                                            <label for="payment_rate_request">
                                                <span>{{ trans('online_booking.event_payment_rates_info') }}</span>
                                            </label>
                                        </div>
                                        <small class="text-muted" style="display: block;padding-left: 27px;line-height:20px;" v-if="event_group">
                                            {{ trans('online_booking.event_payment_rates_details', {number: event_group.payment_rates_number}) }}

                                            <span v-if="event_group.payment_rates_interval == PaymentRateInterval.Weekly"> {{ trans('online_booking.weekly_payment_rate') }}</span>
                                            <span v-else-if="event_group.payment_rates_interval == PaymentRateInterval.Monthly"> {{ trans('online_booking.monthly_payment_rate') }}</span>
                                            <span v-else> {{ trans('online_booking.daily_payment_rate', {number: event_group.payment_rates_interval }) }}</span>
                                            <br>
                                            <span v-if="event_group.pay_before === 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_1', {price: firstPaymentRatePriceWithVatFormatted }) }}</span>
                                            <span v-else-if="event_group.pay_before > 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_2', {price: firstPaymentRatePriceWithVatFormatted }) }}</span>
                                            <span v-else> {{ trans('online_booking.payment_rates_option_3', {name: user.realname, price: firstPaymentRatePriceWithVatFormatted }) }}</span>
                                        </small>
                                        <small class="text-muted" style="display: block;padding-left: 27px;line-height:20px;" v-else>
                                            {{ trans('online_booking.event_payment_rates_details', {number: event.payment_rates_number}) }}

                                            <span v-if="event.payment_rates_interval == PaymentRateInterval.Weekly"> {{ trans('online_booking.weekly_payment_rate') }}</span>
                                            <span v-else-if="event.payment_rates_interval == PaymentRateInterval.Monthly"> {{ trans('online_booking.monthly_payment_rate') }}</span>
                                            <span v-else> {{ trans('online_booking.daily_payment_rate', {number: event.payment_rates_interval }) }}</span>
                                            <br>
                                            <span v-if="event.pay_before === 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_1', {price: firstPaymentRatePriceWithVatFormatted}) }}</span>
                                            <span v-else-if="event.pay_before > 1 && user.is_online_payment_active && user.can_receive_online_payments">{{ trans('online_booking.payment_rates_option_2', {price: firstPaymentRatePriceWithVatFormatted}) }}</span>
                                            <span v-else> {{ trans('online_booking.payment_rates_option_3', {name: user.realname, price: firstPaymentRatePriceWithVatFormatted}) }}</span>
                                        </small>
                                    </div>
                                </div>

                                <div class="form-group m-b-15" :class="{ 'has-error' : errors.has('consent_accepted') }" v-if="is_consent_enabled && consent_settings.required_events && (!logged_in_client || (logged_in_client && (!logged_in_client.consent || logged_in_client.consent.is_consent_outdated)))">
                                    <div class="col-sm-12 m-t-0">
                                        <div class="checkbox">
                                            <input id="consent_accepted_event" type="checkbox" name="consent_accepted" v-model="consent_accepted" required>
                                            <label for="consent_accepted_event">
                                                {{ consent_settings.checkbox_label }}
                                            </label>
                                            <a href="" data-toggle="modal" data-target="#consentModal" >({{ trans('online_booking.read_more') }})</a>
                                        </div>
                                        <span v-show="errors.has('consent_accepted')" class="help-block m-b-0">{{ errors.first('consent_accepted') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between flex-wrap p-6 pt-0">
                    <previous-button :previous-step-id="getPreviousStepId"/>
                    <div>
                        <div v-if="event.pay_before && totalEventPriceToPayNow > 0 && !used_voucher && event.is_payable_with_online_payment && !show_waiting_list">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(1)"
                            >
                                <i class="zmdi zmdi-card mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('vouchers.confirm_and_pay') }}</span>
                                <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            </ep-button>
                        </div>
                        <div v-else-if="!show_waiting_list">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(0)"
                            >
                                <i class="zmdi zmdi-check mr-3"></i>
                                <span class="hidden sm:inline">{{ event_group ? trans('event_groups.subscribe', {event_group_label: trans('event_groups.hardcoded_label').toLowerCase() }) : trans('events.subscribe') }}</span>
                                <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            </ep-button>
                        </div>
                        <div class="flex flex-col" v-if="event.pay_before === 2 && totalEventPriceToPayNow > 0 && !used_voucher && event.is_payable_with_online_payment">
                            <div class="button-divider my-6">
                                <hr>
                                <p>{{ trans('global.or') }}</p>
                                <hr>
                            </div>
                            <ep-button
                                v-if="event.pay_before === 2"
                                :loading="loading"
                                :disabled="loading"
                                variant="secondary"
                                @click="approve(0); loaderOn();"
                            >
                                <i class="zmdi zmdi-check mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('events.subscribe_pay_later') }}</span>
                                <span class="sm:hidden">{{ trans('waiting_list.invitation.pay_later') }}</span>
                            </ep-button>
                        </div>
                        <div v-if="show_waiting_list">
                            <ep-button
                                :loading="loading"
                                :disabled="loading"
                                @click="approve(0)"
                            >
                                <i class="zmdi zmdi-accounts-list mr-3"></i>
                                <span class="hidden sm:inline">{{ trans('waiting_list.event_join') }}</span>
                                <span class="sm:hidden">{{ trans('global.continue') }}</span>
                            </ep-button>
                        </div>
                    </div>
                </div>
            </form>
        </card>
    </div>
</template>
